import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import PaymentAdminPage from "./pages/PaymentAdminPage";
import PaymentResultPage from "./pages/PaymentResultPage";
import BrandedPaymentPage from "./pages/BrandedPaymentPage";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import { CartProvider } from "./context/CartContext";

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
      <div className="App">
        {/* Noise texture overlay */}
        <div className="noise-overlay" />
        
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/paga-admin" element={<PaymentAdminPage />} />
            <Route path="/paga/:ref" element={<BrandedPaymentPage />} />
            <Route path="/pagamento-completato" element={<PaymentResultPage />} />
          </Routes>
        </BrowserRouter>
        
        <Toaster 
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#0A0A0A',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              color: '#fff',
            },
          }}
        />
      </div>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
